import { createActions } from 'redux-actions'

import { createFormActions } from '../../utils/actions'

export const {
  similarJobs: {
    loadSimilarJobs,
    loadSimilarJobsSuccess,
    loadSimilarJobsFailure
  }
} = createActions({
  SIMILAR_JOBS: {
    ...createFormActions('LOAD_SIMILAR_JOBS')
  }
})
